import React from 'react'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { useIsMobile } from 'hooks/useIsMobile'
import PixelDesktop from "./Desktop"


export default function HistorialNav() {
    const { isMobile } = useIsMobile();
    

    return (
        isMobile === "desktop"
            ?
                <PixelDesktop
                    typeView={"desktop"}
                />
            :
                <PixelDesktop 
                    typeView={"movil"}
                />
    )
}
